function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.014,
  stopColor: "#ff0054"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.668,
  stopColor: "#e95c05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffbd00"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_405",
  "data-name": "Path 405",
  d: "M58.905,57.325A16.162,16.162,0,1,1,70.335,29.733l-2.627,2.627a12.447,12.447,0,1,0,0,17.6l2.627,2.627A16.058,16.058,0,0,1,58.905,57.325Z",
  transform: "translate(-42.743 -25)",
  fill: "url(#linear-gradient)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(5.945 5.785)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_406",
  "data-name": "Path 406",
  d: "M257.291,210.416l-.9-.916a.531.531,0,0,0-.721-.032l-.022.02-7.9,6.816-7.134,6.155-4.86-4.711a.527.527,0,0,0-.784.058l-2.69,3.5a.524.524,0,0,0,.043.689l7.9,7.968a.526.526,0,0,0,.373.158h.017a.54.54,0,0,0,.385-.178l9.473-10.922,6.835-7.879.009-.011A.529.529,0,0,0,257.291,210.416Z",
  transform: "translate(-232.178 -209.342)",
  fill: "url(#linear-gradient)"
}));

var SvgGroup1 = function SvgGroup1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_315",
    "data-name": "Group 315",
    width: 31.211,
    height: 32.325,
    viewBox: "0 0 31.211 32.325",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group 1.4280f61a.svg";
export { ForwardRef as ReactComponent };